import React from 'react';

export default function AdminUsers({ users }) {
    return (
        <>
            <h5 className="mb-3">Registered Users</h5>
            <div className="card mb-3">
                <div className="card-body">
                    {users.length === 0 ? (
                        <p className="text-muted mb-0">No registered users found.</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>ID</th>
                                        <th>Username</th>
                                        <th>Display Name</th>
                                        <th>Admin</th>
                                        <th>Joined</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map((u) => (
                                        <tr key={u.id}>
                                            <td>{u.id}</td>
                                            <td>{u.username}</td>
                                            <td>{u.display_name}</td>
                                            <td>{u.is_admin ? <span className="badge bg-danger">Admin</span> : '—'}</td>
                                            <td>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
